import axios from "axios";
import { baseUrlApiOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class LoanService {
  private axios = axios.create({
    // baseURL: "http://localhost:3000",
    baseURL: baseUrlApiOtodis,
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getLoanBpkb(params?: any) {
    try {
      return await this.axios.get<any>("/loan/bpkb", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...params,
        },
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }
}

export const loanService = new LoanService();
